import { Badge, Card, StatCard } from '@/components'
import { cariAngka } from '@/components/LaporanTampil'
import { formatRupiah } from '@/lib/format'
import { HalamanLaporan } from './HalamanLaporan'

/**
 * Neraca (Laporan Posisi Keuangan): Aset = Liabilitas + Aset Neto.
 * Bila API mengembalikan komponennya, kesamaan dihitung dan ditampilkan.
 */
export default function Neraca() {
  return (
    <HalamanLaporan
      judul="Neraca"
      deskripsi="Laporan posisi keuangan: Aset harus sama dengan Liabilitas ditambah Aset Neto."
      path="/reports/balance-sheet"
      namaEkspor="neraca"
      ekstraKonten={(data) => {
        const aset = cariAngka(data, ['totalAset', 'totalAssets', 'jumlahAset'])
        const liabilitas = cariAngka(data, ['totalLiabilitas', 'totalLiabilities', 'jumlahLiabilitas', 'totalKewajiban'])
        const asetNeto = cariAngka(data, ['totalAsetNeto', 'totalNetAssets', 'totalEkuitas', 'totalEquity'])
        const tanpaKewajiban = aset === null || (liabilitas === null && asetNeto === null)

        if (tanpaKewajiban) return null

        const kanan = (liabilitas ?? 0) + (asetNeto ?? 0)
        const selisih = (aset ?? 0) - kanan
        const seimbang = Math.abs(selisih) < 0.005

        return (
          <div className="mb-5 space-y-3">
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
              <StatCard label="Total Aset" nilai={aset} formatNilai={(v) => formatRupiah(Number(v ?? 0))} />
              <StatCard
                label="Total Liabilitas"
                nilai={liabilitas}
                formatNilai={(v) => formatRupiah(Number(v ?? 0))}
              />
              <StatCard
                label="Total Aset Neto"
                nilai={asetNeto}
                formatNilai={(v) => formatRupiah(Number(v ?? 0))}
              />
            </div>
            {seimbang ? (
              <Badge nada="sukses">Seimbang — Aset = Liabilitas + Aset Neto.</Badge>
            ) : (
              <Card className="border-red-300 bg-red-50">
                <p className="text-sm font-semibold text-red-800">Neraca belum seimbang.</p>
                <p className="mt-1 text-sm text-red-700">
                  Selisih {formatRupiah(Math.abs(selisih))}. Periksa jurnal penutup, saldo awal, dan akun
                  antarentitas.
                </p>
              </Card>
            )}
          </div>
        )
      }}
    />
  )
}
